import axios from 'axios';

const API_BANNER_OC_TYPE = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_CART_CHOICE_BANNER}`;

export const getBanner = (param = {}) => axios.get(API_BANNER_OC_TYPE, { params: param });
